import { z } from 'zod'

const httpUrl = z.string().min(1).refine(
  (value) => {
    try {
      const url = new URL(value)
      return url.protocol === 'http:' || url.protocol === 'https:'
    } catch {
      return false
    }
  },
  { message: 'must be a valid http(s) URL' }
)

const EnvSchema = z.object({
  REACT_APP_ADAMO_API_BASE_URL: httpUrl,
  REACT_APP_ADAMO_LANDING_BASE_URL: httpUrl,
  REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV: z
    .string()
    .optional()
    .transform((val) => val === 'true')
})

type Env = z.infer<typeof EnvSchema>

function isActivateSsoInDevRaw(): boolean {
  return process.env.REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV === 'true'
}

function validateEnv(): Env {
  const raw = {
    REACT_APP_ADAMO_API_BASE_URL: process.env.REACT_APP_ADAMO_API_BASE_URL,
    REACT_APP_ADAMO_LANDING_BASE_URL: process.env.REACT_APP_ADAMO_LANDING_BASE_URL,
    REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV: process.env.REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV
  }

  const parsed = EnvSchema.safeParse(raw)

  if (parsed.success) {
    return parsed.data
  }

  const isLocalWithoutSso =
    process.env.NODE_ENV === 'development' && !isActivateSsoInDevRaw()

  console.warn('[SSO Pay] env validation failed:', parsed.error.flatten().fieldErrors, {
    raw
  })

  if (isLocalWithoutSso) {
    console.warn(
      '[SSO Pay] Using placeholder Adamo URLs. Set REACT_APP_ADAMO_* in .env.local and REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV=true for suite SSO.'
    )
    return {
      REACT_APP_ADAMO_API_BASE_URL: 'https://127.0.0.1:9',
      REACT_APP_ADAMO_LANDING_BASE_URL: 'https://127.0.0.1:9',
      REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV: false
    }
  }

  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors)
  throw new Error('Invalid environment variables. Check console for details.')
}

export const env = validateEnv()
